module.exports = __webpack_public_path__ + "img/warning.09228950.svg";